import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import CombinedGroupItem from '../item/combinedGroupItem';
import AbstractCommand from './abstractCommand';

/**
 * Uncombine item command
 *
 * @class UnCombineItemCommand
 * @extends AbstractCommand
 */
export default class UnCombineItemCommand extends AbstractCommand {
    constructor(itemCollection, selection, groupItem) {
        super();
        if (!(groupItem instanceof CombinedGroupItem)) {
            throw new Error('Only combined group item can be uncombined.');
        }

        this.itemCollection = itemCollection;
        this.selection = selection;
        this.groupItem = groupItem;
        this.groupItems = groupItem.getItems();
    }

    /**
     * Execute command
     */
    execute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.groupItem);
        this.itemCollection.add(this.groupItems);

        this.selection.selectItems(this.groupItems, true);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.selection.clear();

        this.groupItem.clearItems();
        this.itemCollection.remove(this.groupItems);
        this.groupItem.addItems(this.groupItems);
        this.itemCollection.add(this.groupItem);

        this.selection.selectItem(this.groupItem, true);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'Uncombine';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.UnCombineItemCommand = UnCombineItemCommand;
